export default __webpack_public_path__ + "static/media/Setting_Dreamless.576bdb59.svg";